import { createLocalCartUuidStore } from '@iheartjane/cart/utils';

/**
 * Pre-convergence key, read so a mid-bag reload across the deploy keeps its
 * cart. Cleared when the uuid is cleared — nothing rewrites it, so a stale value
 * would otherwise be final. A uuid *write* leaves it: the read prefers the new
 * key, so it is already inert.
 *
 * TODO(carts-v3): delete one release after the key move ships.
 */
const LEGACY_CART_UUID_KEY = 'cart-uuid';

const store = createLocalCartUuidStore({
  legacyRead: () => localStorage.getItem(LEGACY_CART_UUID_KEY),
  legacyClear: () => localStorage.removeItem(LEGACY_CART_UUID_KEY),
});

export const getLocalCartUuid = () => store.getLocalCartUuid('kiosk');

export const updateLocalCartUuid = (cartUuid: string | null) =>
  store.updateLocalCartUuid('kiosk', undefined, cartUuid);

/** Subscribed read to ensure it logs the uuid when one is created */
export const useLocalCartUuid = () => store.useLocalCartUuid('kiosk');
